import { portalRoles } from '../../shared/enums/portalRoles';
import { useUserProfileStore } from '../../shared/stores';

export class LoginProfile {
  public get isEmployee() {
    return useUserProfileStore().institutionProfile.role === portalRoles.EMPLOYEE;
  }
}

export const loginProfile = new LoginProfile();
